<category-component></category-component>
<div class="side-space-wrapper  grey-color fixed-header-height">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="d-flex flex-wrap justify-content-between ">
                    <ul class="breadcrumbs d-flex pt-3 pt-md-0 m-0">
                        <li>
                            <a routerLink="/" title="Home">Home</a>
                        </li>

                        <li>
                            <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                        </li>
                        <li>
                            My Orders
                        </li>
                    </ul>

                    <div class="select-past-order">

                        <ng-select [items]="filters" [searchable]="false" bindLabel="name" [virtualScroll]="true"
                            bindValue="filter_key" [(ngModel)]="selectedFilter" (change)="filterChange()">
                        </ng-select>

                    </div>
                </div>
                <div class="table-listing white-bg my-order-table">
                    <h3>My Orders</h3>
                    <div class="accordion-open-default " *ngIf="componentLoaded">
                        <accordion [isAnimated]="true" [closeOthers]="true">
                            <accordion-group [isOpen]="isFirstOpen" *ngFor="let order of orderList">
                                <div class="accordion-heading" accordion-heading>
                                    <div class="status {{orderStatueClasses[order.status]}} d-block d-md-none">
                                        <p>{{order.status}}</p>
                                    </div>

                                    <ul class="items-and-cases">
                                        <li>
                                            <span>Order Date</span>
                                            <p>{{order.created_at | dateTimeFormatFilter : "d MMM, y"}}</p>
                                        </li>
                                        <li class="w-100">
                                            <span>Order ID</span>
                                            <p>{{order.increment_id}}</p>
                                            <ul class="new-border-design">
                                                <li>
                                                    <span>Items</span>
                                                    <p>{{order.total_items}}</p>
                                                </li>

                                                <li *ngIf="global_data?.price_visibility == 1">
                                                    <span>Cost</span>
                                                    <p>£{{order.grand_total}}</p>
                                                </li>
                                                <li>
                                                    <span>Cases</span>
                                                    <p>{{order.total_qty}}</p>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <ul class="table-list-items">

                                    <li>
                                        <span>Store Name</span>
                                        <p>{{order.store_name}}</p>
                                    </li>
                                    <li>
                                        <span>Order Source</span>
                                        <p>{{order.source_order}}</p>
                                    </li>
                                    <li class="status-li {{orderStatueClasses[order.status]}} order-status">
                                        <div class="status ">
                                            <p>{{order.status}}</p>
                                        </div>
                                    </li>
                                    <li class="view-invoice">
                                        <p *ngIf="order.copy_invoice_pdf_name !== null"> <a
                                                href="{{invoicePdfPath}}{{order.copy_invoice_pdf_name}}"
                                                target="_blank">View Invoice</a></p>

                                    </li>
                                    <li class="copy-li" >
                                        <button [ngClass]="order?.is_stationary_order? 'disabled' : ''" type="button" [routerLink]="['/order/order-cart',order.order_id]"
                                            class="view-btn btn primary-btn">Copy Order <img class="px-1" width="20"
                                                src="../../../../assets/images/content_copy.svg" alt=""></button>
                                        <button type="button" [routerLink]="['/order/detail',order.order_id]"
                                            class="view-btn btn primary-btn">View Order</button>
                                    </li>
                                </ul>
                            </accordion-group>

                        </accordion>

                        <div class="view-all-order d-flex d-md-none" #stickyMenu [class.sticky]="sticky">
                            <a class="btn primary-btn" href="javascript:void(0);" (click)="onScrollDown()"
                                *ngIf="(this.nextPage != 1 && this.nextPage !== null) && !this.loading"
                                title="View More">View More</a>
                        </div>
                    </div>
                    <div class="row no-result" *ngIf="componentLoaded && noRecord">
                        <div class="col-12">
                            <div *ngIf="loggedInUser.is_telesales_user || loggedInUser.is_head_office_user">
                                <app-application-id></app-application-id>
                            </div>
                            <div class="no-result-content text-center">
                                <img src="../../assets/images/no-result.svg" alt="no-result">
                                <p>There are no orders for this supplier.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row no-result" *ngIf="!componentLoaded && noRecord">
                        <div class="col-12">
                            <div class="no-result-content text-center">
                                <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                                <p>Loading...</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="view-all-order d-none d-md-flex">
                    <a class="btn primary-btn" href="javascript:void(0);" (click)="onScrollDown()"
                        *ngIf="(this.nextPage != 1 && this.nextPage !== null) && !this.loading" title="View More">View
                        More</a>
                </div>
            </div>
        </div>
    </div>
</div>